import {Button} from '@sportcast/ui-react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {IconSuccess} from '../../components/icons/Icon';
import './ForgotPassword.scss';

const PasswordResetMailSent = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/');
    };

    return (
        <>
            <div className="icon-success">
                <IconSuccess/>
            </div>

            <h5 className="my-4">{t('forgotPassword.PASSWORD_SET')}</h5>

            <div className="explanation">
                {t('forgotPassword.PASSWORD_SET_CONFIRMATION')}
            </div>

            <div className="mt-5 text-right">
                <Button
                    id="send-link"
                    className="w-60"
                    variant="primary"
                    type="submit"
                    label={t('forgotPassword.TO_LOGIN')}
                    onClick={() => handleClick()}
                />
            </div>
        </>
    );
};

export default PasswordResetMailSent;
